// Notifications Synchronization and Handlers

$(document).ready(function() {
  // 1. Mark as read from Bell Dropdown
  $(document).on('click', '.dropdown-notifications-read', function(e) {
    e.preventDefault();
    e.stopPropagation();
    var $btn = $(this);
    var $item = $btn.closest('.dropdown-notifications-item');
    var id = $item.data('id');
    
    markAsRead(id);
  });

  // 2. Mark as read from Dashboard
  $(document).on('click', '.btn-mark_notification_read', function(e) {
    e.preventDefault();
    var id = $(this).data('notification-id');
    
    markAsRead(id);
  });

  // 2.5 Archive/Delete individual notification
  $(document).on('click', '.dropdown-notifications-archive', function(e) {
    e.preventDefault();
    e.stopPropagation();
    var id = $(this).closest('.dropdown-notifications-item').data('id');
    console.log('Archiving notification:', id);
    
    $.ajax({
      url: '/notifications/' + id,
      method: 'DELETE',
      dataType: 'json',
      headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
      success: function(data) {
        console.log('Archived successfully:', id);
        $('[data-id="' + id + '"]').fadeOut(300, function() { $(this).remove(); });
        $('#mta_notification_' + id).fadeOut(300, function() { $(this).remove(); });
        updateNavTotalCounters(data.unread_count);
      },
      error: function(xhr, status, error) {
        console.error('Error archiving:', error);
        alert('Error al eliminar: ' + error);
      }
    });
  });

  // 2.7 Click on notification item to redirect
  $(document).on('click', '.dropdown-notifications-item', function(e) {
    if ($(e.target).closest('.dropdown-notifications-read, .dropdown-notifications-archive').length) return;
    
    var url = $(this).data('url');
    if (url) {
      window.location.href = url;
    }
  });

  // 3. Clear All
  $(document).on('click', '.dropdown-notifications-all-clear, .dashboard-notifications-all-clear', function(e) {
    e.preventDefault();
    if (!confirm(translate_js.confirm_clear_all)) return;
    var ids = [];
    var $visibleItems;
    
    if ($(this).hasClass('dashboard-notifications-all-clear')) {
      $visibleItems = $('.notification_item:visible').filter(function() {
        return $(this).find('.btn-delete_notification').length > 0;
      });
    } else {
      $visibleItems = $('.dropdown-notifications-item:visible').filter(function() {
        return $(this).find('.dropdown-notifications-archive').length > 0;
      });
    }
    
    $visibleItems.each(function() {
      ids.push($(this).data('id'));
    });
    
    if (ids.length === 0) {
      alert(translate_js.no_notifications_to_clear);
      return;
    }
    
    console.log('Clearing filtered notifications:', ids);
    
    $.ajax({
      url: '/notifications/clear_all',
      method: 'DELETE',
      data: { ids: ids },
      dataType: 'json',
      headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
      success: function(data) {
        console.log('Cleared all successfully');
        $('.dropdown-notifications-item').each(function() {
          if ($(this).find('.dropdown-notifications-archive').length > 0) {
            $(this).fadeOut(300, function() { $(this).remove(); });
          }
        });
        var clearedCount = 0;
        ids.forEach(function(id) {
          var $dashItem = $('#mta_notification_' + id);
          if ($dashItem.length) {
            $dashItem.fadeOut(300, function() { 
              $(this).remove(); 
              clearedCount++;
              if (clearedCount === ids.length) {
                $(document).trigger('notifications:updated');
              }
            });
          } else {
            clearedCount++;
            if (clearedCount === ids.length) {
              $(document).trigger('notifications:updated');
            }
          }
        });
        updateNavTotalCounters(0);
        $('#mta_unread_notification_counter').text('0');
        
        // Show empty message in dropdown
        var prevCount = $('.dropdown-notifications-list').data('previous-years-count');
        var html = '<div class="d-flex flex-center flex-column py-10 py-lg-15"><i class="fas fa-bell-slash fs-2tx text-muted mb-5"></i><span class="text-muted fw-bold">No hay notificaciones nuevas ni recientes</span></div>';
        
        if (prevCount > 0) {
          html += '<div class="alert bg-light-warning d-flex align-items-center p-3 mb-3 mt-3"><i class="fas fa-exclamation-triangle text-warning me-2"></i><span class="fs-8 text-warning fw-bold">Las notificaciones pendientes no son del año en curso.</span></div>';
        }
        
        $('.dropdown-notifications-list').html(html);
      },
      error: function(xhr, status, error) {
        console.error('Error clearing all:', error);
        alert('Error al eliminar todas: ' + error);
      }
    });
  });

  // 4. Mark All as Read
  $(document).on('click', '.dropdown-notifications-all-read, .dashboard-notifications-all-read', function(e) {
    e.preventDefault();
    if (!confirm(translate_js.confirm_mark_all_read)) return;
    var ids = [];
    var $visibleItems;
    
    if ($(this).hasClass('dashboard-notifications-all-read')) {
      $visibleItems = $('.notification_item:visible').filter(function() {
        return $(this).find('.btn-mark_notification_read').length > 0;
      });
    } else {
      $visibleItems = $('.dropdown-notifications-item:visible').filter(function() {
        return $(this).find('.dropdown-notifications-read').length > 0;
      });
    }
    
    $visibleItems.each(function() {
      ids.push($(this).data('id'));
    });
    
    if (ids.length === 0) {
      alert(translate_js.no_notifications_to_read);
      return;
    }
    
    console.log('Marking filtered notifications as read:', ids);
    
    $.ajax({
      url: '/notifications/mark_all_as_read',
      method: 'POST',
      data: { ids: ids },
      dataType: 'json',
      headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
      success: function(data) {
        console.log('Marked all as read successfully');
        $('.dropdown-notifications-item').each(function() {
          if ($(this).find('.dropdown-notifications-read').length > 0) {
            $(this).fadeOut(300, function() { 
              $(this).remove(); 
              if ($('.dropdown-notifications-item').length === 0) {
                var prevCount = $('.dropdown-notifications-list').data('previous-years-count');
                var html = '<div class="d-flex flex-center flex-column py-10 py-lg-15"><i class="fas fa-bell-slash fs-2tx text-muted mb-5"></i><span class="text-muted fw-bold">No hay notificaciones nuevas ni recientes</span></div>';
                if (prevCount > 0) {
                  html += '<div class="alert bg-light-warning d-flex align-items-center p-3 mb-3 mt-3"><i class="fas fa-exclamation-triangle text-warning me-2"></i><span class="fs-8 text-warning fw-bold">Las notificaciones pendientes no son del año en curso.</span></div>';
                }
                $('.dropdown-notifications-list').html(html);
              }
            });
          }
        });
        
        // Update dashboard items too
        ids.forEach(function(id) {
          var $dashItem = $('#mta_notification_' + id);
          if ($dashItem.length) {
            $dashItem.addClass('read');
            var $btn = $dashItem.find('.btn-mark_notification_read');
            if ($btn.length > 0) {
              $btn.fadeOut(200, function() { $(this).remove(); });
              if ($dashItem.find('.badge.bg-success').length === 0) {
                $dashItem.find('.text-muted.me-2.fs-7 small').after('<span class="badge badge-sm bg-success ms-1">' + translate_js.read_badge + '</span>');
              }
            }
          }
        });
        
        updateNavTotalCounters(0);
        $('#mta_unread_notification_counter').text('0');
      },
      error: function(xhr, status, error) {
        console.error('Error marking all as read:', error);
        alert('Error al marcar todas como leídas: ' + error);
      }
    });
  });

  // 5. Toggle previous years notifications
  $(document).on('click', '#btn-show-previous-years', function(e) {
    e.preventDefault();
    $('#previous-years-notifications').slideToggle();
    var $btn = $(this);
    if ($btn.text().indexOf(translate_js.show_previous_years) > -1) {
      $btn.text(translate_js.hide_previous_years);
    } else {
      $btn.text($btn.data('original-text'));
    }
  });

  // 6. Delete individual notification from dashboard
  $(document).on('click', '.btn-delete_notification', function(e) {
    e.preventDefault();
    var id = $(this).data('notification-id');
    if (!confirm('¿Eliminar esta notificación?')) return;
    
    $.ajax({
      url: '/notifications/' + id,
      method: 'DELETE',
      dataType: 'json',
      headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
      success: function(data) {
        $('#mta_notification_' + id).fadeOut(300, function() { $(this).remove(); });
        $('[data-id="' + id + '"]').fadeOut(300, function() { $(this).remove(); }); // Remove from dropdown too!
        updateNavTotalCounters(data.unread_count);
      },
      error: function(xhr, status, error) {
        console.error('Error deleting notification:', error);
        alert('Error al eliminar la notificación: ' + error);
      }
    });
  });
});

function markAsRead(id) {
  $.ajax({
    url: '/notifications/' + id + '/mark_as_read',
    method: 'POST',
    dataType: 'json',
    headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
    beforeSend: function() {
      // No opacity effect
    },
    success: function(data) {
      // Update Bell Dropdown
      var $bellItem = $('.dropdown-notifications-item[data-id="' + id + '"]');
      if ($bellItem.length) {
        $bellItem.fadeOut(300, function() { 
          $(this).remove(); 
          // Show the next hidden unread notification if any
          var $hiddenItems = $('.dropdown-notifications-item.d-none');
          if ($hiddenItems.length) {
            $hiddenItems.first().removeClass('d-none').hide().fadeIn(300);
          }
          
          // Update counter
          var shown = $('.dropdown-notifications-item:visible').length;
          var total = data.unread_count;
          $('.total-unread-badge').text(shown + '/' + total + ' Nueva(s)');
          
          // Check if no more notifications left
          if ($('.dropdown-notifications-item').length === 0) {
            var prevCount = $('.dropdown-notifications-list').data('previous-years-count');
            var html = '<div class="d-flex flex-center flex-column py-10 py-lg-15"><i class="fas fa-bell-slash fs-2tx text-muted mb-5"></i><span class="text-muted fw-bold">No hay notificaciones nuevas ni recientes</span></div>';
            if (prevCount > 0) {
              html += '<div class="alert bg-light-warning d-flex align-items-center p-3 mb-3 mt-3"><i class="fas fa-exclamation-triangle text-warning me-2"></i><span class="fs-8 text-warning fw-bold">Las notificaciones pendientes no son del año en curso.</span></div>';
            }
            $('.dropdown-notifications-list').html(html);
          }
        });
      }
      
      // Update Dashboard
      var $dashItem = $('#mta_notification_' + id);
      if ($dashItem.length) {
        $dashItem.css('opacity', '');
        $dashItem.addClass('read');
        $dashItem.find('.btn-mark_notification_read').fadeOut(200, function() { $(this).remove(); });
        if ($dashItem.find('.badge.bg-success').length === 0) {
          $dashItem.find('.text-muted.me-2.fs-7 small').after('<span class="badge badge-sm bg-success ms-1">' + translate_js.read_badge + '</span>');
        }
      }
      
      // Update Dashboard counter (decrement by 1 only if not in previous years)
      if ($dashItem.length && !$dashItem.closest('#previous-years-notifications').length) {
        var $counter = $('#mta_unread_notification_counter');
        var currentCount = parseInt($counter.text()) || 0;
        if (currentCount > 0) {
          $counter.text(currentCount - 1);
        }
      }
      
      updateNavTotalCounters(data.unread_count);
    },
    error: function() {
      $('[data-id="' + id + '"]').css('opacity', '');
      $('#mta_notification_' + id).css('opacity', '');
    }
  });
}

function updateNavTotalCounters(count) {
  $('.badge-notifications').text(count).toggleClass('d-none', parseInt(count) === 0);
  $('.pulse-ring').toggleClass('d-none', parseInt(count) === 0);
  $('.total-unread-badge').text(count + ' Nueva(s)');
  
  if (parseInt(count) === 0) {
    $('#notifications_bell_toggle span.svg-icon').removeClass('svg-icon-danger').addClass('svg-icon-muted');
  } else {
    $('#notifications_bell_toggle span.svg-icon').removeClass('svg-icon-muted').addClass('svg-icon-danger');
  }
}

window.updateNavTotalCounters = updateNavTotalCounters;
